export const PADDING_BETWEEN_ELEMENTS = 25;
export const PADDING_BETWEEN_ROWS = 25;
export const BREAKPOINT_SPACING = 1;
